import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { hasuraClient } from '../../utils/graphqlClient';
import { GET_PERMISSIONS_QUERY } from '../../graphql';

const initialState = {
  permissions: [],
  permissionMap: {},
  isLoading: false,
  error: null,
  initialized: false,
};

export const fetchPermissions = createAsyncThunk(
  'permissions/fetch',
  async ({ role, companyId }, { rejectWithValue }) => {
    try {
      const data = await hasuraClient.query(GET_PERMISSIONS_QUERY, {
        role,
        companyId,
      });
      return data.permissions;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const permissionSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    clearPermissions: (state) => {
      state.permissions = [];
      state.permissionMap = {};
      state.initialized = false;
      state.error = null;
    },
    setPermissionMap: (state, action) => {
      const permissionMap = {};
      action.payload.forEach(permission => {
        const key = `${permission.screen}_${permission.company_id}`;
        permissionMap[key] = {
          canCreate: permission.can_create,
          canEdit: permission.can_edit,
          canView: permission.can_view,
          canDelete: permission.can_delete,
          canDownload: permission.can_download,
        };
      });
      state.permissionMap = permissionMap;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPermissions.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPermissions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.permissions = action.payload;
        state.initialized = true;
        
        const permissionMap = {};
        action.payload.forEach(permission => {
          const key = `${permission.screen}_${permission.company_id}`;
          permissionMap[key] = {
            canCreate: permission.can_create,
            canEdit: permission.can_edit,
            canView: permission.can_view,
            canDelete: permission.can_delete,
            canDownload: permission.can_download,
          };
        });
        state.permissionMap = permissionMap;
      })
      .addCase(fetchPermissions.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        state.initialized = true;
      });
  },
});

export const { clearPermissions, setPermissionMap } = permissionSlice.actions;

export const selectPermissions = (state) => state.permissions.permissions;
export const selectPermissionMap = (state) => state.permissions.permissionMap;
export const selectPermissionsLoading = (state) => state.permissions.isLoading;
export const selectPermissionsError = (state) => state.permissions.error;
export const selectPermissionsInitialized = (state) => state.permissions.initialized;

export default permissionSlice.reducer; 